module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }